import http from '../plugins/axios';

const loadTypeLocations = async () => {
    const response = await http.get('/api/company/v3/location/types');
    return response.data;
};
const loadTypeAttractions = async () => {
    const response = await http.get('/api/company/v3/attraction/types');
    return response.data;
};


export {loadTypeLocations, loadTypeAttractions};